<template>
  <div class="card card-body rounded-top">
    <div style="margin-top: 1em" class="row">
      <div class="form-group col-md-6">
        <w-input :model="$schema.firstName" :title="$t($schema.firstName.$schema.title)" />
      </div>

      <div class="form-group col-md-6">
        <w-input :model="$schema.lastName" :title="$t($schema.lastName.$schema.title)" />
      </div>
    </div>

    <div class="form-group">
      <w-input :model="$schema.email" :title="$t($schema.email.$schema.title)" />
    </div>

    <div class="form-group">
      <w-input :model="$schema.phoneNumber" :title="$t($schema.phoneNumber.$schema.title)" />
    </div>

    <div class="form-group">
      <w-input :model="$schema.education" :title="$t($schema.education.$schema.title)" />
    </div>

    <div class="form-group">
      <w-textarea :model="$schema.jobHistory" :title="$t($schema.jobHistory.$schema.title)" />
    </div>

    <div class="form-group">
      <w-textarea :model="$schema.achievements" :title="$t($schema.achievements.$schema.title)" />
    </div>

    <div class="row">
      <div class="form-group col-md-6">
        <form-datepicker :model="$schema.birthDate" :title="$t($schema.birthDate.$schema.title)" />
      </div>
    </div>

    <div class="col-12">
      <button class="btn btn-smart btn-lg float-right rounded-pill" @click="save">
        {{ $t('buttons.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/profile.schema';

const emptyData = () => ({
  email: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  birthDate: '',
  jobHistory: ' ',
  achievements: ' ',
  education: '',
  lang: ''
});

export default {
  mixins: [
    formViewMixin(
      'profile',
      { updated: 'messages.profile.updated', updateError: 'messages.profile.updateError' },
      emptyData
    )
  ],
  schema
};
</script>
